
import React, { useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Sparkles, Send } from 'lucide-react';

interface InputBarProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  handleSendMessage: () => void;
  isLoading: boolean;
  isOpen: boolean;
}

const InputBar: React.FC<InputBarProps> = ({
  inputValue,
  setInputValue,
  handleSendMessage,
  isLoading,
  isOpen
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isOpen]);

  return (
    <div className="relative mt-auto">
      <Input
        ref={inputRef}
        placeholder="Ask me anything about news or articles..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className="pr-10"
        disabled={isLoading}
      />
      <Button 
        size="sm" 
        className="absolute right-0 top-0 bottom-0 h-full aspect-square"
        onClick={handleSendMessage}
        disabled={!inputValue.trim() || isLoading}
      >
        {isLoading ? (
          <Sparkles className="h-4 w-4 animate-spin" />
        ) : (
          <Send className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
};

export default InputBar;
